import { DirectDonations } from "./DirectDonations/DirectDonations";
import { RoundDonations } from "./RoundDonations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DonationsHistory(_ref) {
  let {
    contributionsData
  } = _ref;
  const {
    contributionsByStatusAndHashAndRoundId,
    contributionsToDirectGrants
  } = contributionsData !== null && contributionsData !== void 0 ? contributionsData : {};
  const activeRoundDonations = contributionsByStatusAndHashAndRoundId === null || contributionsByStatusAndHashAndRoundId === void 0 ? void 0 : contributionsByStatusAndHashAndRoundId.active;
  const pastRoundDonations = contributionsByStatusAndHashAndRoundId === null || contributionsByStatusAndHashAndRoundId === void 0 ? void 0 : contributionsByStatusAndHashAndRoundId.past;
  const directAllocationDonations = contributionsToDirectGrants;
  const directAllocationDonationsArray = directAllocationDonations ? Object.values(directAllocationDonations).flat() : [];
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-12",
    children: [/*#__PURE__*/_jsx(RoundDonations, {
      title: "Active Rounds",
      contributions: activeRoundDonations
    }), /*#__PURE__*/_jsx(RoundDonations, {
      title: "Past Rounds",
      contributions: pastRoundDonations
    }), directAllocationDonationsArray.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex items-center h-[45px] border-black text-black text-lg/[26px] border-b font-modern-era-medium font-medium",
        children: "Direct Donations"
      }), /*#__PURE__*/_jsx(DirectDonations, {
        contributions: directAllocationDonationsArray
      })]
    })]
  });
}